import axios from 'axios';

const state = {
    listDocumentTemplates: [],
    listIdNameDocumentTemplates: null
};

const mutations = {
    setListDocumentTemplates(state, payload) {
        state.listDocumentTemplates = payload;
    },
    setListIdNameDocumentTemplates(state, payload) {
        state.listIdNameDocumentTemplates = payload;
    },
};

const actions = {
    setListDocumentTemplates({ commit }, payload) {
        commit("setListDocumentTemplates", payload);
    },
    setListIdNameDocumentTemplates({ commit }, payload) {
        commit("setListIdNameDocumentTemplates", payload);
    },
    getListDocumentTemplates({ rootGetters, state, commit }) {
        return new Promise(async (resolve) => {
            if (state.listDocumentTemplates && state.listDocumentTemplates.length) {
                resolve(state.listDocumentTemplates);
                return;
            }
            let res = await axios.get(
                `/api/documenttemplates/?agency=${rootGetters.agencyID}`
            );
            if (res && res.data) {
                commit('setListDocumentTemplates', res.data);
                resolve(res.data);
                return;
            }
            commit('setListDocumentTemplates', []);
            resolve([]);
        });
    },
    getListIdNameDocumentTemplates({ rootGetters, getters, commit, state }, isReload = false) {
        return new Promise(async (resolve) => {
            if (!isReload) {
                if (state.listIdNameDocumentTemplates) {
                    resolve(getters.listIdNameDocumentTemplates);
                    return;
                }
            }
            let res = await axios.get(
                `/api/documenttemplates/?agency=${rootGetters.agencyID}&id_name=true`
            );
            if (res && res.data) {
                commit('setListIdNameDocumentTemplates', res.data);
                resolve(res.data);
                return;
            }
            commit('setListIdNameDocumentTemplates', []);
            resolve([]);
        });
    },
    async getDocumentTemplateById(_, templateId) {
        const res = await axios.get(`/api/documenttemplates/${templateId}`);
        if (res && res.data) {
            return res.data;
        }
    }
};

const getters = {
    listDocumentTemplates(state) {
        return state.listDocumentTemplates;
    },
    listIdNameDocumentTemplates(state) {
        if (state.listDocumentTemplates && state.listDocumentTemplates.length) {
            return state.listDocumentTemplates;
        }
        return state.listIdNameDocumentTemplates || [];
    }
};

export default {
    state,
    mutations,
    actions,
    getters
};



// WEBPACK FOOTER //
// ./src/store/modules/document-template.js